import React, { useEffect, useState } from "react";
import { getDocs, collection, query, orderBy, doc, limit, startAfter, getDoc, where } from "firebase/firestore";
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import ConfessionCard from "../utilities/components/ConfessionCard"
import ConfessionCardSkelton from "../utilities/components/ConfessionCardSkelton"
import { db } from "../config/FirebaseConfig";
import styles from './Home.module.css';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import Stack from '@mui/material/Stack';
import Pagination from '@mui/material/Pagination';
import AdSense from 'react-adsense';
import categoriesConst from "../utilities/constants/Constants"

var randomMC = require('random-material-color');


const PAGE_LIMIT =  10

function Home({isAuth}) {
  
  const [postLists, setPostList] = useState([]);
  const [categories, setCategories] = useState(categoriesConst);
  const [selectedCategory, setSelectedCategory] = useState(categoriesConst[0]);
  const [isLoading, setIsLoading] = useState(true);
  const [startAfterValue, setStartAfterValue] = useState(0);
  const [countOfPosts, setCountOfPosts] = useState(0);
  const [sortBy, setSortBy] = useState('date');
  const [allCategoriesCounts, setAllCategoriesCounts] = useState();
  

  const postsCollectionRef = collection(db, "posts");
  const likesCollectionRef = collection(db, "likes");

  const serverStamp = firebase.firestore.Timestamp


  const getPosts = async () => {
    setIsLoading(true)
    let latestDoc = postLists[postLists.length-1];
    //startAt Only works when it's not the first call
    if(selectedCategory.categoryCode == 1){
      const data = latestDoc? await getDocs(query(postsCollectionRef, orderBy(sortBy, "desc"), limit(PAGE_LIMIT), startAfter(latestDoc))) : 
                            await getDocs(query(postsCollectionRef, orderBy(sortBy, "desc"), limit(PAGE_LIMIT)))
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setIsLoading(false)
    }
    else{
      const data = latestDoc? await getDocs(query(postsCollectionRef, orderBy(sortBy, "desc"), limit(PAGE_LIMIT), startAfter(latestDoc), where('categoryCode' , '==', selectedCategory.categoryCode))) : 
                            await getDocs(query(postsCollectionRef, orderBy(sortBy, "desc"), limit(PAGE_LIMIT), where('categoryCode' , '==', selectedCategory.categoryCode)))
      setPostList(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      setIsLoading(false)
    }
  };

  const getPostsCount = async () => {
    let sfuIdInCountCollection = 'T0h0L5acIUJ9zRnZ30AO'
    let posts_count = 'posts_count'
    const docRef = doc(db, posts_count, sfuIdInCountCollection);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      let selectedCategoryCode = selectedCategory.categoryCode
      if(selectedCategoryCode == 1){
        setCountOfPosts(docSnap.data().count_posts || 0)
      }else{
        setCountOfPosts(docSnap.data()[selectedCategoryCode] || 0)
      }
      setAllCategoriesCounts(docSnap.data())
      console.log("count stuff yo: ", docSnap.data())
    } else {
      console.log("No document for count");
    }
  }


  useEffect(() => {
    //setPostList([]) // to prevent calling 'startAfter' when rendering first time
    getPosts()
  }, [sortBy, startAfterValue]);

  useEffect(() => {
    getPosts()
    getPostsCount()
  }, [selectedCategory])

  // useEffect(() => {
  //   getPostsCount()
  // }, [])

  let generateColor = (text) => {
    return randomMC.getColor({ text: text });
  }

  const handleSorting = (event, sortType) => {
    setPostList([])
    setSortBy(sortType);
  };

  const handlePaginationChange = (event, pageNumber) => {
    setStartAfterValue((pageNumber-1) * 2)
  }



  return (
    <Grid container>
      <Box 
        sx={{ width: '100%' }}
        display="flex"
        justifyContent="center"
        //className={styles.mainBox}
      >
      <Grid container display="flex"
      justifyContent="center" xs={12}>
      <Grid item xs={12}>
      <Grid container display="flex" justifyContent="center">
      {categories.map((category) => {
        return(
          // <Badge 
          //   badgeContent={100}
          //   showZero
          //   className={styles.badge}
          //   color="secondary"
          //   overlap="circular"
          //   anchorOrigin={{
          //     vertical: 'top',
          //     horizontal: 'right',
          //   }}
          // >
            
          // </Badge>
          (category.categoryCode ==1 ||( allCategoriesCounts && allCategoriesCounts[category.categoryCode])) &&
            <Chip
              variant={"outlined"}
              className={styles.badge}
              sx={{mr: 2}}
              label={category.categoryValue}
              style={{
                borderColor: generateColor(category.categoryValue) || '#000', 
                background: selectedCategory.categoryValue === category.categoryValue ? '#d9d9d9' : null
              }}
              onDelete={selectedCategory.categoryValue !== 'All' && 
                        selectedCategory.categoryValue === category.categoryValue ?
                        () => setSelectedCategory(categoriesConst[0]) : null
                      }
              onClick={() => {setSelectedCategory(category); setPostList([])}} 
              //className={styles.chip} 
              //icon={icon}
              //onClick={handleClick}
            />
        )
      })}
      </Grid>
      </Grid>
      <Grid item xs={11} sm={9} md={6} sx={{mt: 3}}>
          {!isLoading?
              [
                <ToggleButtonGroup
                  value={sortBy}
                  exclusive
                  onChange={handleSorting}
                  aria-label="Sort By"
                >
                  <ToggleButton value="date" aria-label="left aligned">
                    <AccessTimeIcon />
                  </ToggleButton>
                  <ToggleButton value="likedByCount" aria-label="centered">
                    <WhatshotIcon />
                  </ToggleButton>
                </ToggleButtonGroup>
                ,
              postLists.map((post) => {
              return(
                <ConfessionCard
                  text={post.text}
                  date={post.date}
                  name={post.author && post.author.name}
                  isAuth={isAuth}
                  likedByIds={post.likedBy}
                  disLikedByIds={post.disLikedBy}
                  post_id={post.id}
                  categoryCode={post.categoryCode}
                />
                )
              })]
          :
            [<ConfessionCardSkelton/>,
            <ConfessionCardSkelton/>,
            <ConfessionCardSkelton/>]
          }
      </Grid>
      </Grid>
      </Box>
      <AdSense.Google
              client='ca-pub-7292810486004926'
              slot='7806394673'
              style={{ display: 'block' }}
              layout='in-article'
              format='fluid'
            />
      <Grid container justifyContent="center">
        <Pagination
        sx={{mb: 5}} 
        count={Math.ceil(countOfPosts / PAGE_LIMIT)}
        color="error" 
        onChange={handlePaginationChange}
        />
      </Grid>
      <script async src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"></script>
    </Grid>
  );
}

export default Home;
